import { rootClient, publicClient } from "./config/rootClient";

// ===================== AUTH =====================
export const login = (payload) => publicClient.post("/auth/login", payload).then((r) => r.data);
export const logout = () => rootClient.post("/auth/logout");
export const markTutorialSeen = (tutorialId) => rootClient.post(`/auth/tutorials/${tutorialId}/seen`);

// ===================== DASHBOARD =====================
export const getDashboardSummary = () => rootClient.get("/dashboard/summary");

// ===================== DOCTORS =====================
export const getDoctors = (params) => rootClient.get("/doctors", { params });
export const getDoctor = (id) => rootClient.get(`/doctors/${id}`);
export const createDoctor = (payload) => rootClient.post("/doctors", payload);
export const updateDoctor = (id, payload) => rootClient.put(`/doctors/${id}`, payload);
export const deleteDoctor = (id) => rootClient.delete(`/doctors/${id}`);
export const setDoctorActive = (id, active) => rootClient.put(`/doctors/${id}/active`, { active });
export const getDoctorAppointments = (id, params) => rootClient.get(`/doctors/${id}/appointments`, { params });
export const resetDoctorLoginPassword = (id) => rootClient.post(`/doctors/${id}/reset-login-password`);

export const addDoctorLeave = (id, payload) => rootClient.post(`/doctors/${id}/leaves`, payload);
export const removeDoctorLeave = (id, leaveId) => rootClient.delete(`/doctors/${id}/leaves/${leaveId}`);

export const setDoctorDelay = (id, payload) => rootClient.put(`/doctors/${id}/delay`, payload);
export const clearDoctorDelay = (id) => rootClient.delete(`/doctors/${id}/delay`);

export const getDoctorAttendanceToday = () => rootClient.get("/doctors/attendance/today");
export const checkInDoctor = (id) => rootClient.post(`/doctors/${id}/check-in`);
export const checkOutDoctor = (id) => rootClient.post(`/doctors/${id}/check-out`);
export const getDoctorAttendanceHistory = (params) => rootClient.get("/doctors/attendance", { params });

// ===================== PATIENTS =====================
export const getPatients = (params) => rootClient.get("/patients", { params });
export const getPatient = (id) => rootClient.get(`/patients/${id}`);
export const createPatient = (payload) => rootClient.post("/patients", payload);
export const updatePatient = (id, payload) => rootClient.put(`/patients/${id}`, payload);
export const getPatientAppointments = (id, params) => rootClient.get(`/patients/${id}/appointments`, { params });
export const getPatientGeoDistribution = (params) => rootClient.get("/patients/geo", { params });

// ===================== APPOINTMENTS =====================
export const getAppointments = (params) => rootClient.get("/appointments", { params });
export const getAppointment = (id) => rootClient.get(`/appointments/${id}`);
export const getAvailableSlots = (params) => rootClient.get("/appointments/available-slots", { params });
export const getAppointmentAgents = () => rootClient.get("/appointments/agents");
export const getAppointmentStats = (params) => rootClient.get("/appointments/stats", { params });
export const getAppointmentPunctuality = (params) => rootClient.get("/appointments/punctuality", { params });
export const getPatientRetention = (params) => rootClient.get("/appointments/patient-retention", { params });
export const getDoctorLeaveImpact = (params) => rootClient.get("/appointments/doctor-leave-impact", { params });
export const createAppointment = (payload) => rootClient.post("/appointments", payload);
export const editAppointment = (id, payload) => rootClient.patch(`/appointments/${id}/edit`, payload);
export const checkInAppointment = (id) => rootClient.patch(`/appointments/${id}/check-in`);
export const markAppointmentContacted = (id, payload) => rootClient.patch(`/appointments/${id}/contact`, payload);
export const cancelAppointment = (id, payload) => rootClient.patch(`/appointments/${id}/cancel`, payload);
export const remindAppointment = (id) => rootClient.post(`/appointments/${id}/remind`);

// ===================== MESSAGES =====================
export const getMessages = (params) => rootClient.get("/messages", { params });

// ===================== USER MASTER (super-admin only) =====================
export const getAdminUsers = (params) => rootClient.get("/users", { params });
export const createAdminUser = (payload) => rootClient.post("/users", payload);
export const updateAdminUser = (id, payload) => rootClient.put(`/users/${id}`, payload);
export const resetAdminUserPassword = (id) => rootClient.post(`/users/${id}/reset-password`);
export const deleteAdminUser = (id) => rootClient.delete(`/users/${id}`);

// ===================== CALL CENTER (outbound live via MCube) =====================
export const clickToCall = (patientId) => rootClient.post("/call-center/click-to-call", { patient_id: patientId });
export const getCallLogs = (params) => rootClient.get("/call-center/logs", { params });
export const getCallAgentAnalytics = (params) => rootClient.get("/call-center/analytics", { params });

// ===================== INVOICES / BILLING =====================
export const getInvoiceByAppointment = (appointmentId) => rootClient.get(`/invoices/by-appointment/${appointmentId}`);
export const saveInvoiceForAppointment = (appointmentId, payload) => rootClient.put(`/invoices/by-appointment/${appointmentId}`, payload);
export const sendInvoiceForAppointment = (appointmentId) => rootClient.post(`/invoices/by-appointment/${appointmentId}/send`);
export const getInvoices = (params) => rootClient.get("/invoices", { params });

// ===================== LAB ORDERS =====================
export const getLabTests = (params) => rootClient.get("/lab/catalog/tests", { params });
export const findLabs = (params) => rootClient.get("/lab/labs", { params });

export const getLabOrders = (params) => rootClient.get("/lab/orders", { params });
export const getLabOrder = (id) => rootClient.get(`/lab/orders/${id}`);
export const createLabOrder = (payload) => rootClient.post("/lab/orders", payload);
export const updateLabOrderStatus = (id, payload) => rootClient.patch(`/lab/orders/${id}/status`, payload);
export const rescheduleLabOrder = (id, payload) => rootClient.patch(`/lab/orders/${id}/reschedule`, payload);

// ===================== LAB MASTER (master role) =====================
export const getMasterLabTests = (params) => rootClient.get("/lab/master/tests", { params });
export const createMasterLabTest = (payload) => rootClient.post("/lab/master/tests", payload);
export const updateMasterLabTest = (id, payload) => rootClient.put(`/lab/master/tests/${id}`, payload);
export const deleteMasterLabTest = (id) => rootClient.delete(`/lab/master/tests/${id}`);

export const getMasterLabs = (params) => rootClient.get("/lab/master/labs", { params });
export const createMasterLab = (payload) => rootClient.post("/lab/master/labs", payload);
export const updateMasterLab = (id, payload) => rootClient.put(`/lab/master/labs/${id}`, payload);
export const deleteMasterLab = (id) => rootClient.delete(`/lab/master/labs/${id}`);

// ===================== PRESCRIPTIONS =====================
export const getPrescriptions = (params) => rootClient.get("/prescriptions", { params });
export const getPrescriptionByAppointment = (appointmentId) => rootClient.get(`/prescriptions/by-appointment/${appointmentId}`);
export const savePrescriptionByAppointment = (appointmentId, payload) => rootClient.put(`/prescriptions/by-appointment/${appointmentId}`, payload);
export const sendPrescription = (appointmentId) => rootClient.post(`/prescriptions/by-appointment/${appointmentId}/send`);

export const getCatalogMedicines = (params) => rootClient.get("/prescriptions/catalog/medicines", { params });
export const getCatalogTerms = (params) => rootClient.get("/prescriptions/catalog/terms", { params });
export const quickAddTerm = (payload) => rootClient.post("/prescriptions/catalog/terms/quick-add", payload);

// ===================== MEDICINE MASTER (master role) =====================
export const getMasterMedicines = (params) => rootClient.get("/prescriptions/master/medicines", { params });
export const createMasterMedicine = (payload) => rootClient.post("/prescriptions/master/medicines", payload);
export const updateMasterMedicine = (id, payload) => rootClient.put(`/prescriptions/master/medicines/${id}`, payload);
export const deleteMasterMedicine = (id) => rootClient.delete(`/prescriptions/master/medicines/${id}`);

// ===================== CLINICAL TERM MASTER (master role) =====================
export const getMasterTerms = (params) => rootClient.get("/prescriptions/master/terms", { params });
export const createMasterTerm = (payload) => rootClient.post("/prescriptions/master/terms", payload);
export const updateMasterTerm = (id, payload) => rootClient.put(`/prescriptions/master/terms/${id}`, payload);
export const deleteMasterTerm = (id) => rootClient.delete(`/prescriptions/master/terms/${id}`);

// ===================== DEPARTMENTS =====================
export const getDepartments = (params) => rootClient.get("/departments", { params });
export const createDepartment = (payload) => rootClient.post("/departments", payload);
export const updateDepartment = (id, payload) => rootClient.put(`/departments/${id}`, payload);
export const deleteDepartment = (id) => rootClient.delete(`/departments/${id}`);

// ===================== SETTINGS =====================
export const getSettings = () => rootClient.get("/settings");
export const updateClinicSettings = (payload) => rootClient.put("/settings/clinic", payload);
export const updateSchedulingSettings = (payload) => rootClient.put("/settings/scheduling", payload);
export const updateBillingSettings = (payload) => rootClient.put("/settings/billing", payload);
export const updateNotificationSettings = (payload) => rootClient.put("/settings/notifications", payload);
export const updateDisplaySettings = (payload) => rootClient.put("/settings/display", payload);

// ===================== ACTIVITY LOG =====================
export const getActivityLog = (params) => rootClient.get("/activity", { params });

// ===================== NOTIFICATIONS =====================
export const getNotifications = (params) => rootClient.get("/notifications", { params });
export const markNotificationRead = (id) => rootClient.patch(`/notifications/${id}/read`);
export const markAllNotificationsRead = () => rootClient.patch("/notifications/read-all");

// ===================== PLATFORM ADMIN (Aivexa-internal, cross-clinic) =====================
export const getPlatformClinics = () => rootClient.get("/platform/clinics");
export const getPlatformClinicSettings = (key) => rootClient.get(`/platform/clinics/${key}/settings`);
export const updatePlatformClinicFeature = (key, payload) => rootClient.put(`/platform/clinics/${key}/settings/features`, payload);
export const getAppReleases = () => rootClient.get("/platform/app-releases");
export const updateCurrentAppRelease = (payload) => rootClient.put("/platform/app-releases/current", payload);

// Diagnostics — department worklists and report files
export const getDiagnosticDepartments = () => rootClient.get("/diagnostics/departments");
export const getDiagnosticWorklist = (params) => rootClient.get("/diagnostics/worklist", { params });
export const uploadDiagnosticReport = (orderId, code, formData, onUploadProgress) =>
  rootClient.post(`/diagnostics/orders/${orderId}/items/${encodeURIComponent(code)}/reports`, formData, { onUploadProgress });
export const deleteDiagnosticReport = (orderId, code, reportId) =>
  rootClient.delete(`/diagnostics/orders/${orderId}/items/${encodeURIComponent(code)}/reports/${reportId}`);
export const getDiagnosticReportFile = (reportId) =>
  rootClient.get(`/diagnostics/reports/${reportId}/file`, { responseType: "blob" });
export const getPatientDiagnosticReports = (patientId) => rootClient.get(`/diagnostics/patients/${patientId}/reports`);

export const getMasterDiagnosticDepartments = (params) => rootClient.get("/diagnostics/master/departments", { params });
export const createDiagnosticDepartment = (payload) => rootClient.post("/diagnostics/master/departments", payload);
export const updateDiagnosticDepartment = (id, payload) => rootClient.put(`/diagnostics/master/departments/${id}`, payload);
export const deleteDiagnosticDepartment = (id) => rootClient.delete(`/diagnostics/master/departments/${id}`);

export const updatePlatformClinicModules = (key, payload) => rootClient.put(`/platform/clinics/${key}/settings/modules`, payload);
export const sendDiagnosticReport = (orderId, code, reportId, payload) =>
  rootClient.post(`/diagnostics/orders/${orderId}/items/${encodeURIComponent(code)}/reports/${reportId}/send`, payload);

// ===================== LEADS + CHATBOT =====================
export const getLeads = (params) => rootClient.get("/leads", { params });
export const getLeadSummary = () => rootClient.get("/leads/summary");
export const getLead = (id) => rootClient.get(`/leads/${id}`);
export const addLeadNote = (id, text) => rootClient.post(`/leads/${id}/notes`, { text });
export const createLead = (payload) => rootClient.post("/leads", payload);
export const updateLead = (id, payload) => rootClient.patch(`/leads/${id}`, payload);
export const getLeadConversations = (params) => rootClient.get("/leads/conversations", { params });
export const getLeadConversation = (id) => rootClient.get(`/leads/conversations/${id}`);
export const interveneLeadConversation = (id) => rootClient.post(`/leads/conversations/${id}/intervene`);
export const replyLeadConversation = (id, text) => rootClient.post(`/leads/conversations/${id}/reply`, { text });
export const handBackLeadConversation = (id) => rootClient.post(`/leads/conversations/${id}/hand-back`);
export const approveLeadConversation = (id, payload) => rootClient.post(`/leads/conversations/${id}/approve`, payload);
export const closeLeadConversation = (id, payload) => rootClient.post(`/leads/conversations/${id}/close`, payload);
export const simulateLeadMessage = (id, text) => rootClient.post(`/leads/conversations/${id}/simulate`, { text });
export const getChatbotSettings = () => rootClient.get("/leads/chatbot-settings");
export const updateChatbotSettings = (payload) => rootClient.put("/leads/chatbot-settings", payload);
export const getAssistantStats = () => rootClient.get("/leads/assistant-stats");

// ===================== PLATFORM ADMIN: LEAD ASSISTANT =====================
export const getPlatformAssistantSettings = (key) => rootClient.get(`/platform/clinics/${key}/assistant/settings`);
export const updatePlatformAssistantSettings = (key, payload) => rootClient.put(`/platform/clinics/${key}/assistant/settings`, payload);
export const getPlatformAssistantStats = (key) => rootClient.get(`/platform/clinics/${key}/assistant/stats`);
export const getPlatformUnanswered = (key) => rootClient.get(`/platform/clinics/${key}/assistant/unanswered`);
export const platformTeach = (key, payload) => rootClient.post(`/platform/clinics/${key}/assistant/teach`, payload);
export const platformDismiss = (key, messageIds) => rootClient.post(`/platform/clinics/${key}/assistant/dismiss`, { message_ids: messageIds });
export const getAwaitingReply = () => rootClient.get("/leads/awaiting-reply");
